module.exports = __webpack_public_path__ + "img/22s.54b21e15.png";